export const PRIORITY_ENDPOINTS = {
  base: '/priorities',
  byId: (id: string) => `/priorities/${id}`,
  entityLinks: (entityId: string) => `/priorities/links/entity/${entityId}`,
  checkSimilarName: '/priorities/check-similar-name',
};
